import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeleteDraftModalService {
    readonly selectedOrderId$ = new BehaviorSubject<number | null>(null);
    readonly deletedSuccessfully$ = new Subject<number>();

    deletedSuccessfully(orderId: number) {
        this.deletedSuccessfully$.next(orderId);
    }
}
